import { ApiHttpService } from '../ApiHttpService';
import { InstallationOptionSerializer } from '../serializers/InstallationOptionSerializer';
import { InstallationOption } from '../../models/InstallationOption';
import { ParamsHelper } from '../../helpers/ParamsHelper';

const INSTALLATION_PATH = 'usuario/OpcionesInstalacion';
const COORDINATION_PATH = 'usuario/AgregarInstalacionesPedido';

class InstallationOptionsController {
  static async all(addressId, installationAmount, date) {
    const authenticated = true;
    const queryParams = ParamsHelper.createQueryParams({
      cupos: installationAmount,
      fechaInstalacion: date.toISOString(),
      idDireccion: addressId,
    });
    const response = await ApiHttpService.post(`${INSTALLATION_PATH}${queryParams}`, {}, authenticated);
    const deSerializedOptions = InstallationOptionSerializer.deSerialize(response.data || []);
    return deSerializedOptions.map(data => new InstallationOption(data));
  }

  static async allByArticle(addressId, installationAmount, date, idArticle) {
    const authenticated = true;
    const queryParams = ParamsHelper.createQueryParams({
      cupos: installationAmount,
      fechaInstalacion: date.toISOString(),
      idDireccion: addressId,
      idArticulo: idArticle,
    });
    const response = await ApiHttpService.post(`${INSTALLATION_PATH}${queryParams}`, {}, authenticated);
    const deSerializedOptions = InstallationOptionSerializer.deSerialize(response.data || []);
    return deSerializedOptions.map(data => new InstallationOption(data));
  }

  static serializeCoordination(checkoutId, installations) {
    return {
      Pedido: checkoutId,
      Instalaciones: installations.map(data => ({
        IDArticulo: data.productId,
        InstalacionesSinCoordinar: data.remainingInstallations,
        Instalaciones: data.selectedOptions.map(option => ({
          Cantidad: option.amount,
          Fecha: option.date.toISO(),
          HoraI: option.startHour,
          HoraF: option.endHour,
        })),
      })),
    };
  }

  static coordinate(checkoutId, productId, installations) {
    const authenticated = true;
    const serializedData = InstallationOptionsController.serializeCoordination(
      checkoutId,
      productId,
      installations,
    );
    return ApiHttpService.post(COORDINATION_PATH, serializedData, authenticated);
  }
}

export { InstallationOptionsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/InstallationOptionsController.js